<aside class="sidebar" [class.open]="isOpen">
  <!-- Main Section Header -->
  <div class="sidebar-header">
    <span class="section-label">Main</span>
    <button class="toggle-btn" (click)="toggleSidebar()">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M12 2L6 8L12 14" stroke="currentColor" stroke-width="2" />
      </svg>
    </button>
  </div>

  <!-- Main Menu Items -->
  <nav class="menu-section">
    <a
      *ngFor="let item of mainMenuItems"
      [routerLink]="item.route"
      routerLinkActive="active"
      class="menu-item"
    >
      {{ item.label }}
    </a>
  </nav>

  <div class="divider"></div>

  <!-- Bottom Section -->
  <div class="bottom-section">
    <div class="section-label">Main</div>

    <a *ngFor="let item of bottomMenuItems" class="menu-item small">
      <img
        *ngIf="item.icon === 'settings'"
        class="menu-icon"
        src="/assets/icons/settings-icon.svg"
        alt="Settings"
      />
      <img
        *ngIf="item.icon === 'profile'"
        class="menu-icon"
        src="/assets/icons/profile-icon.svg"
        alt="Profile"
      />
      {{ item.label }}
    </a>
  </div>
</aside>
